export default __webpack_public_path__ + "static/media/commander_xp_3.c62a1b57.png";